// @flow

import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import SMConst from 'frontend_core/dist/constants/sm-const'
import ReservationModel from 'frontend_core/dist/model/Reservation'
import {
  fontSize,
  spacing,
  zIndexes,
} from 'frontend_core/dist/styles/variables'
import Colors from 'components/styles/colors'
import { mediaMin } from 'frontend_core/dist/styles/media'
import MediaSpace from 'components/molecules/MediaSpace'
import LinkText from 'components/atoms/LinkText'
import ReservationDate from 'components/molecules/ReservationDate'
import ReservationSidebarBlock from 'components/molecules/ReservationSidebarBlock'
import ReservationRequestBlock from 'components/molecules/ReservationRequestBlock'
import BillStatementCurrent, {
  type PropTypes as BillStatementCurrentProps,
} from 'components/molecules/BillStatementCurrent'
import ReservationGetPointBlock, {
  type PropTypes as ReservationGetPointBlockProps,
} from 'components/molecules/ReservationGetPointBlock'
import Path from 'routes/path'

import ReservationHostActionBlock from 'components/molecules/ReservationHostActionBlock'
import ReservationUseScheduleBlock from 'components/molecules/ReservationUseScheduleBlock'
import ReservationEventBlock from 'components/molecules/ReservationEventBlock'
import ReservationAddress from 'components/molecules/ReservationAddress'

const SectionTitle = styled.p`
  color: ${Colors.black};
  font-size: ${fontSize.medium}px;
  ${mediaMin.phone`
    font-size: ${fontSize.medium_2}px;
  `};
`
const MenuListItem = styled.li`
  &:not(:first-of-type) {
    border-top: 1px solid ${Colors.grayE};
  }
`
const ContentListItem = styled.li`
  padding: ${spacing.medium_2}px 0;

  &:not(:first-of-type) {
    border-top: 1px solid ${Colors.grayE};
  }

  &:last-of-type {
    padding: ${spacing.medium_2}px 0 0;
  }

  i {
    font-size: ${fontSize.small}px;
    margin-left: ${spacing.small}px;
  }
`
const ReservationEventBlockWrapper = styled.div`
  margin-top: ${spacing.medium_2}px;
`
const ReservationRequestBlockWrapper = styled.div`
  margin-top: ${spacing.medium_2}px;
`
const ReservationViewDetail = styled.div`
  margin-top: ${spacing.small_3}px;
`

export type PropTypes = {
  spaceImageUrl: string,
  spaceName: string,
  dateText?: ?string,
  paymentMethod?: ?string,
  onClickChangeCreditCard?: Function,
  billStatementCurrentProps: ?BillStatementCurrentProps,
  reservationGetPointBlockProps: ?ReservationGetPointBlockProps,
  changeEndedAt: moment | Date | string,

  canBeCancelled: boolean,
  canBeEdited: boolean,
  hasChangeRequestFromOwner: boolean,
  hasChangeRequestFromUser: boolean,
  onClickCancel: Function,
  onClickChangeReservation?: Function,
  onClickConfirmChangeReservation?: Function,
  onClickConfirmChangeReservationFromHost?: Function,
}

export default function ReservationDetailSection(props: PropTypes) {
  return (
    <div>
      <SectionTitle>
        {i18n.t('page.dashboard.reservation.reservationDetails')}
      </SectionTitle>
      <ul>
        <ContentListItem>
          <MediaSpace
            src={props.spaceImageUrl}
            text={props.spaceName}
            spaceUrl={props.spaceUrl}
          />
        </ContentListItem>
        {props.dateText && (
          <ContentListItem>
            <ReservationDate dateText={props.dateText} />
          </ContentListItem>
        )}
        {props.paymentMethod && (
          <ContentListItem>
            <ReservationSidebarBlock
              title={i18n.t('page.dashboard.reservation.payingMethod')}
              text={props.paymentMethod}
              onClickChangeCreditCard={props.onClickChangeCreditCard}
            />
            <ReservationViewDetail>
              <LinkText
                href={Path.helpPayment()}
                target="_blank"
                fontSizePc="12"
              >
                {i18n.t('page.dashboard.reservation.viewDetail')}
                <i className="icon icon-spm-right" />
              </LinkText>
            </ReservationViewDetail>
          </ContentListItem>
        )}
        <ContentListItem>
          {props.billStatementCurrentProps && (
            <BillStatementCurrent {...props.billStatementCurrentProps} />
          )}
          {props.reservationGetPointBlockProps && (
            <ReservationGetPointBlock
              {...props.reservationGetPointBlockProps}
            />
          )}
          <ReservationRequestBlockWrapper>
            <ReservationRequestBlock
              canBeCancelled={props.canBeCancelled}
              canBeEdited={props.canBeEdited}
              hasChangeRequestFromOwner={props.hasChangeRequestFromOwner}
              hasChangeRequestFromUser={props.hasChangeRequestFromUser}
              changeEndedAt={props.changeEndedAt}
              onClickCancel={props.onClickCancel}
              onClickChangeReservation={props.onClickChangeReservation}
              onClickConfirmChangeReservation={
                props.onClickConfirmChangeReservation
              }
              onClickConfirmChangeReservationFromHost={
                props.onClickConfirmChangeReservationFromHost
              }
            />
          </ReservationRequestBlockWrapper>
        </ContentListItem>
      </ul>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/organisms/ReservationDetailSection/index.jsx